import axiosInstance from "../../utils/axios";

export const getProjectLists = async () => {
    const res = await axiosInstance.get(`/project/get_projects`);
    return res;
};

export const getBlocks = async () => {
    const res = await axiosInstance.get(`/tracker_row/block_id_names`);
    return res;
}